import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";

const API_URL = `${API_BASE_URL}/jugadorEstadisticas`;

export const getJugadorEstaditicasByIdGrupoAndIdTemporada = async (
  idGrupo,
  idTemporada,
  navigate
) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}?idGrupo=${idGrupo}&idTemporada=${idTemporada}`,
      {
        method: "GET",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener los datos");
  } catch (error) {
    throw error;
  }
};

export const getJugadorEstaditicasByIdCompeticionAndIdTemporada = async (
  idCompeticion,
  idTemporada,
  navigate
) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}?idCompeticion=${idCompeticion}&idTemporada=${idTemporada}`,
      {
        method: "GET",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener los datos");
  } catch (error) {
    throw error;
  }
};

export const getJugadorEstaditicasByIdAndIdTemporada = async (
  idTemporada,
  id,
  navigate
) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}?idTemporada=${idTemporada}&id=${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener los datos");
  } catch (error) {
    throw error;
  }
};

export const getJugadoresByLetrasJugador = async (letrasNombre, navigate, { signal } = {}) => {
  try {
    const nombreNormalizado = String(letrasNombre || "").trim();
    const response = await fetchWithAuth(
      `${API_URL}?letrasNombre=${encodeURIComponent(nombreNormalizado)}`,
      {
        method: "GET",
        cache: "no-cache",
        signal,
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener los datos");
  } catch (error) {
    throw error;
  }
};

export const getEstadisticasJugadorById = async (idJugador, navigate) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}?idJugador=${idJugador}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener los datos");
  } catch (error) {
    throw error;
  }
};

export const getEstadisticasJugadoresByIdCompeticionAndIdEquipo = async (
  idCompeticion,
  idEquipo,
  navigate
) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}?idCompeticion=${idCompeticion}&idEquipo=${idEquipo}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener los datos");
  } catch (error) {
    throw error;
  }
};

export const getEstadisticasJugadoresByIdTemporadaAndIdEquipo = async (
  idTemporada,
  idEquipo,
  navigate
) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}?idTemporada=${idTemporada}&idEquipo=${idEquipo}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener los datos");
  } catch (error) {
    throw error;
  }
};
